import type { TourDefinition } from '../types';

export const activitiesTour: TourDefinition = {
  id: 'activities',
  title: 'Atividades',
  steps: [
    {
      element: '[data-tour="activities-create-btn"]',
      popover: {
        title: 'Nova Atividade',
        description:
          'Crie ligações, emails, reuniões e tarefas para organizar seu dia.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="activities-view-toggles"]',
      popover: {
        title: 'Modos de Visualização',
        description:
          'Alterne entre Lista e Calendário para gerenciar suas atividades.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="activities-type-badges"]',
      popover: {
        title: 'Tipos de Atividade',
        description:
          'Identifique rapidamente o tipo de cada atividade pelos ícones e cores.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="activities-period-tabs"]',
      popover: {
        title: 'Períodos',
        description:
          'Filtre atividades por Hoje, Esta Semana ou Este Mês.',
        side: 'bottom',
        align: 'start',
      },
    },
  ],
};
